/* "Pirk kartu pigiau" add-ons on the desk page (snippets/erx-addons.liquid). Owner pick 2026-10-20, design G3.
   - Tap a card to pick it, the dots choose its colour. Nothing goes to the cart on the tap.
   - The page's own "Į krepšelį" (and the phone bar's) then adds the desk AND the picked add-ons in ONE /cart/add.js
     through cart.js's queue, the way cart.js addUpsellToCart already adds [desk, upsell]. With nothing picked this file
     stands aside and erx-chair.js adds the desk exactly as before (one add, one add_to_cart in the dataLayer).
   - Each card's price = cart.js _upsellPriceParts(...) for a cart that holds the desk: the same number the cart's own
     upsell cards show and the codes it applies (bundle -5 %, ARM15, MAT15, PAD15) then charge.
   - The arm and the drawer follow the desk frame colour (black frame -> black, white -> white) until a dot is tapped,
     as the cable-tray gift does in the cart.
   - Hidden in the Įmonei mode (quantities and tiers per desk there), except where the snippet carries data-erx-ao-biz
     (the chair's castors, owner 2026-11-04 "upsell ratukai nepradingti"): there the row stays, and a pick is one set
     per chair, so the cards, the button total and the add all follow the Įmonei stepper. */
(() => {
  const root = document.querySelector('[data-erx-ao]');
  if (!root || root.dataset.ready) return;
  /* launch switch: false = only for ?erxao=1 (testing on the live theme), true = everyone */
  const LIVE = true;
  if (!LIVE && !/[?&]erxao=1\b/.test(location.search)) return;
  root.dataset.ready = '1';
  root.hidden = false;
  const $ = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => Array.from((r || document).querySelectorAll(s));
  let data;
  try { data = JSON.parse($('[data-erx-ao-data]', root).textContent); } catch (e) { return; }
  const items = {};
  (data.items || []).forEach(it => { items[it.key] = it; });
  let ch = {};
  try { ch = JSON.parse(($('#erx-ch-data') || {}).textContent || '{}'); } catch (e) {}
  const deskVariants = ch.variants || [];
  const T = ch.t || {};
  const top = root.closest('[data-erx-ch-top]') || $('[data-erx-ch-top]');
  const track = $('[data-erx-ao-track]', root);
  const money = c => (window.formatMoney ? window.formatMoney(c) : (c / 100).toFixed(2).replace('.', ',') + ' €');
  const picked = new Set();
  const manual = {};
  let mode = 'me';
  /* data-erx-ao-biz: the row also works in Įmonei mode; n = chairs on the stepper there, 1 otherwise */
  const BIZ = root.hasAttribute('data-erx-ao-biz');
  let n = 1, bizTotal = 0, bizSub = null;
  const on = () => mode === 'me' || BIZ;

  const card = k => $('[data-erx-ao-card="' + k + '"]', root);
  const variantOf = k => {
    const it = items[k], el = card(k);
    if (!it || !el) return null;
    const c = +el.dataset.c;
    return it.v.find(v => v.c === c) || it.v.find(v => v.ok) || null;
  };
  const deskId = () => String(($('#variant-id-input') || {}).value || window.currentSelectedVariant || '');
  const deskVariant = () => deskVariants.find(v => String(v.id) === deskId()) || null;
  const FALLBACK = { chair: p => Math.round(p * 0.95), arm: p => Math.round(p * 0.85), mouse: p => Math.round(p * 0.85),
    cups: p => Math.round(p * 0.85), mat: p => p - ((((window.cartStrings || {}).omniMatCuts) || {}).mat || 1000), drawer: p => p };
  const withDesk = (k, v) => {
    const it = items[k];
    try {
      if (window.cart && typeof window.cart._upsellPriceParts === 'function') {
        const parts = window.cart._upsellPriceParts(it.canon, it.piece || '', { price: v.price, compare_at_price: v.cmp },
          { items: [{ handle: data.desk, quantity: 1 }] });
        if (parts && typeof parts.bundlePrice === 'number' && parts.bundlePrice > 0) return parts.bundlePrice;
      }
    } catch (e) { /* cart.js not ready: the first-paint rule below is the same rule */ }
    return (FALLBACK[k] || (p => p))(v.price);
  };

  const paintCard = k => {
    const el = card(k), v = variantOf(k);
    if (!el || !v) return;
    const bp = withDesk(k, v);
    const on = picked.has(k);
    el.classList.toggle('is-on', on);
    const hit = $('[data-erx-ao-toggle]', el);
    if (hit) {
      hit.setAttribute('aria-pressed', on ? 'true' : 'false');
      hit.setAttribute('aria-label', items[k].name + ', ' + money(bp).replace(/&#160;|&nbsp;/g, ' '));
    }
    const now = $('[data-erx-ao-now]', el), was = $('[data-erx-ao-was]', el), img = $('[data-erx-ao-img]', el);
    if (now) now.innerHTML = (n > 1 ? n + '&nbsp;×&nbsp;' : '') + money(bp);
    if (was) { was.innerHTML = money(v.price); was.hidden = !(bp < v.price); }
    if (img && v.img && img.getAttribute('src') !== v.img) img.setAttribute('src', v.img);
    $$('[data-erx-ao-dot]', el).forEach(d => d.classList.toggle('is-on', +d.dataset.erxAoDot === v.c));
  };

  const totals = () => {
    const dv = deskVariant();
    let add = 0, save = 0;
    const names = [];
    picked.forEach(k => {
      const v = variantOf(k);
      if (!v) return;
      const bp = withDesk(k, v);
      add += bp * n; save += Math.max(0, v.price - bp) * n;
      names.push(items[k].name);
    });
    return { desk: dv ? dv.price : 0, add, save, names, deskOk: !!(dv && dv.available !== false) };
  };

  const paintTotals = () => {
    const t = totals();
    const active = on() && picked.size > 0;
    if (mode === 'me') {
      const atc = top && $('[data-erx-atc]', top);
      if (atc && !atc.disabled && T.atc) atc.innerHTML = active ? T.atc + ' · ' + money(t.desk + t.add) : T.atc;
      if (t.desk) $$('[data-erx-bar-price]').forEach(el => { el.innerHTML = money(t.desk + (active ? t.add : 0)); });
    } else if (BIZ && bizTotal) {
      /* erx-chair.js painted "[qty] vnt. · [total]" for the chairs alone; the picked sets go on top */
      const sum = bizTotal + (active ? t.add : 0);
      const atc = top && $('[data-erx-atc]', top);
      if (atc && !atc.disabled && T.atcBiz) atc.innerHTML = String(T.atcBiz).replace(/\[qty\]/g, n).replace(/\[total\]/g, money(sum));
      $$('[data-erx-bar-price]').forEach(el => { el.innerHTML = money(sum); });
      /* the bar's "4 vnt. × 246,05 €" line names the sets too, so its total adds up */
      if (bizSub != null) $$('[data-erx-bar-sub]').forEach(el => { el.textContent = bizSub + (active ? ' + ' + t.names.join(' + ') : ''); });
    }
    const row = $('[data-erx-ao-save]', root);
    if (row) {
      row.hidden = !active || t.save <= 0;
      $('[data-erx-ao-names]', row).textContent = t.names.join(' + ');
      $('[data-erx-ao-saving]', row).innerHTML = money(t.save);
    }
  };
  const paintAll = () => { Object.keys(items).forEach(paintCard); paintTotals(); };

  /* arm + drawer follow the frame colour until the shopper picks one */
  const followFrame = () => {
    const dv = deskVariant();
    if (!dv) return;
    const c = dv.f === 'white' ? 1 : 0;
    ['arm', 'drawer'].forEach(k => {
      if (manual[k] || !items[k]) return;
      const v = items[k].v.find(x => x.c === c);
      if (v && v.ok && card(k)) card(k).dataset.c = c;
    });
  };

  const toggle = k => {
    if (picked.has(k)) picked.delete(k); else picked.add(k);
    paintCard(k); paintTotals();
  };

  /* the drawer needs a tabletop from 140 x 70 cm (drawer FAQ; the cart's own upsell already skips it for 120 x 60):
     with the 120 x 60 desk its card hides and is unpicked, and it comes back on 140 / 160 (owner 2026-10-21) */
  const sizeFit = () => {
    const el = card('drawer');
    if (!el) return;
    const dv = deskVariant();
    const no = !!(dv && String(dv.s) === '120');
    if (no && picked.has('drawer')) picked.delete('drawer');
    el.hidden = no;
  };

  root.addEventListener('click', e => {
    /* the + badge sits on the photo, above the photo's "open the preview" button: it still picks at once */
    const badge = e.target.closest('.erx-ao__badge');
    if (badge && badge.closest('[data-erx-ao-card]')) { toggle(badge.closest('[data-erx-ao-card]').dataset.erxAoCard); return; }
    const op = e.target.closest('[data-erx-qv-open]');
    if (op) { qvOpen(op.closest('[data-erx-ao-card]').dataset.erxAoCard, op); return; }
    const dot = e.target.closest('[data-erx-ao-dot]');
    if (dot) {
      const el = dot.closest('[data-erx-ao-card]'), k = el.dataset.erxAoCard;
      if (dot.disabled) return;
      el.dataset.c = dot.dataset.erxAoDot;
      manual[k] = true;
      picked.add(k);
      paintCard(k); paintTotals();
      return;
    }
    const hit = e.target.closest('[data-erx-ao-toggle]');
    if (hit) { toggle(hit.closest('[data-erx-ao-card]').dataset.erxAoCard); return; }
    const nav = e.target.closest('[data-erx-ao-nav]');
    if (nav && track) {
      const c = track.firstElementChild, step = c ? c.getBoundingClientRect().width + 14 : 156;
      track.scrollBy({ left: +nav.dataset.erxAoNav * step, behavior: 'smooth' });
    }
  });

  /* ---------- quick preview (design "4 · Didelė nuotrauka", Figma w36IQ 2636:932, owner pick 2026-10-21) ----------
     A tap on a card's photo opens: computer = a window, the photos as big as the screen allows on the left, name, price,
     colours, three facts and "Pridėti su stalu" on the right; phone = a tall sheet, the whole photo first. Photos are the
     product's own for this market (snippets/erx-qv-imgs.liquid), picked here by colour / piece from the file name, and load
     only on open. "Pridėti" picks the item in the chosen colour and closes; the main button then adds everything, as before.
     Closes on X, the dimmed page, Esc and a swipe down on the handle. No Trustpilot line and no quote
     (owner 2026-10-21). Each open pushes erx_quick_view to the dataLayer. */
  let W = null;
  try { W = JSON.parse(($('[data-erx-qv-words]', root) || {}).textContent || 'null'); } catch (e) { W = null; }
  /* launch switch, like LIVE above: false = only with ?erxqv=1 (testing on the live theme), true = everyone */
  const QV_LIVE = true; /* on for everyone since 2026-10-21 (owner: "ok šitą darom", critic 9/10, QA 10 sizes) */
  const qvOn = !!(W && W.ui) && (QV_LIVE || /[?&]erxqv=1\b/.test(location.search));
  if (qvOn) $$('[data-erx-qv-open], .erx-ao__zoom', root).forEach(b => { b.hidden = false; });
  const chairPage = data.desk === 'ergonomic-chair';
  const qv = { k: null, c: 0, opener: null, el: null, i: 0 };
  const esc = t => String(t == null ? '' : t).replace(/[&<>"]/g, ch => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[ch]);
  const ICON = {
    x: '<svg viewBox="0 0 20 20" width="18" height="18" fill="none" aria-hidden="true"><path d="M5 5l10 10M15 5L5 15" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>',
    l: '<svg viewBox="0 0 20 20" width="18" height="18" fill="none" aria-hidden="true"><path d="M12 5l-5 5 5 5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    r: '<svg viewBox="0 0 20 20" width="18" height="18" fill="none" aria-hidden="true"><path d="M8 5l5 5-5 5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    f: ['',
      '<svg viewBox="0 0 20 20" width="20" height="20" fill="none" aria-hidden="true"><path d="M10 2.5l6 2.2v4.6c0 3.6-2.5 6.6-6 7.9-3.5-1.3-6-4.3-6-7.9V4.7l6-2.2z" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round"/><path d="M7.3 10l1.9 1.9 3.6-3.8" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      '<svg viewBox="0 0 20 20" width="20" height="20" fill="none" aria-hidden="true"><path d="M3.75 10a6.25 6.25 0 1 0 1.83-4.42" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/><path d="M3.75 3.75v3.33h3.33" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg>'],
    ok: '<svg viewBox="0 0 16 16" width="14" height="14" fill="none" aria-hidden="true"><path d="M3.5 8.3l2.9 2.9 6.1-6.4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>'
  };
  /* the first fact is always a size (height, cm, inches): a ruler */
  const RULER = '<svg viewBox="0 0 20 20" width="20" height="20" fill="none" aria-hidden="true"><path d="M7 3v14M7 3l-2 2M7 3l2 2M7 17l-2-2M7 17l2-2M12 6h4M12 10h3M12 14h4" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  const pics = (it, v) => {
    const toks = String(it.tk || '').split('~').filter(Boolean).map(t => new RegExp(t));
    const others = toks.filter((t, i) => i !== v.c);
    const pc = it.pc ? new RegExp(it.pc) : null;
    let g = (it.g || []).filter(x => (!pc || pc.test(x[1])) && !others.some(r => r.test(x[1])));
    const vn = String(v.img || '').split('/').pop().split('?')[0].toLowerCase();
    g = g.filter(x => x[1] === vn).concat(g.filter(x => x[1] !== vn));
    /* the chair opens on its first in-use slide, as in the approved design; the plain photo follows */
    if (it.lead) { const ld = new RegExp(it.lead); g = g.filter(x => ld.test(x[1])).concat(g.filter(x => !ld.test(x[1]))); }
    if (!g.length && v.img) g = [[String(v.img).replace(/width=\d+/, 'width=1200'), vn]];
    return g.slice(0, 10).map(x => x[0]);
  };
  const srcset = u => /width=\d+/.test(u) ? u.replace(/width=\d+/, 'width=640') + ' 640w, ' + u.replace(/width=\d+/, 'width=1200') + ' 1200w' : '';

  const qvBuild = () => {
    if (qv.el) return qv.el;
    const el = document.createElement('div');
    el.className = 'erx-qv';
    el.hidden = true;
    el.innerHTML = '<div class="erx-qv__scrim" data-qv-close></div>' +
      '<div class="erx-qv__box" role="dialog" aria-modal="true" aria-labelledby="erx-qv-nm">' +
        '<div class="erx-qv__top" data-qv-drag><span class="erx-qv__grab"></span><button type="button" class="erx-qv__x" data-qv-close aria-label="' + esc(W.ui.close) + '">' + ICON.x + '</button></div>' +
        '<div class="erx-qv__media"><div class="erx-qv__track" data-qv-track></div>' +
          '<button type="button" class="erx-qv__nav erx-qv__nav--l" data-qv-nav="-1" aria-label="' + esc(W.ui.prev) + '">' + ICON.l + '</button>' +
          '<button type="button" class="erx-qv__nav erx-qv__nav--r" data-qv-nav="1" aria-label="' + esc(W.ui.next) + '">' + ICON.r + '</button>' +
          '<span class="erx-qv__pd" data-qv-pd aria-hidden="true"></span></div>' +
        '<div class="erx-qv__info"><div class="erx-qv__scroll">' +
          '<h3 class="erx-qv__nm" id="erx-qv-nm" data-qv-nm></h3>' +
          '<p class="erx-qv__pr"><span class="erx-qv__now" data-qv-now></span><s class="erx-qv__was" data-qv-was></s><span class="erx-qv__note" data-qv-note></span></p>' +
          '<div class="erx-qv__col" data-qv-col><p class="erx-qv__colab">' + esc(W.ui.colour) + ': <b data-qv-cname></b></p><span class="erx-qv__dots" data-qv-dots></span></div>' +
          '<ul class="erx-qv__facts" data-qv-facts></ul>' +
        '</div><div class="erx-qv__foot"><p class="erx-qv__deliv" data-qv-deliv hidden></p><button type="button" class="erx-qv__add" data-qv-add></button><p class="erx-qv__tot" data-qv-tot></p></div></div>' +
      '</div>';
    document.body.appendChild(el);
    qv.el = el;
    /* computer: the page's own delivery line (same order, same words and dates as under the main button) */
    const pd = top && $('.erx-ch-deliv', top), dl = $('[data-qv-deliv]', el);
    if (pd && dl && pd.textContent.trim()) { dl.innerHTML = pd.innerHTML; dl.hidden = false; }
    const track = $('[data-qv-track]', el);
    el.addEventListener('click', e => {
      if (e.target.closest('[data-qv-close]')) { qvClose(); return; }
      const nav = e.target.closest('[data-qv-nav]');
      if (nav) { qvGo(qv.i + +nav.dataset.qvNav); return; }
      const d = e.target.closest('[data-qv-dot]');
      if (d && !d.disabled) { qv.c = +d.dataset.qvDot; qvPaint(true); qvFit(); return; }
      if (e.target.closest('[data-qv-add]')) {
        const k = qv.k, on = picked.has(k) && +card(k).dataset.c === qv.c;
        if (on) { picked.delete(k); paintCard(k); paintTotals(); qvPaint(false); return; }
        card(k).dataset.c = qv.c; manual[k] = true; picked.add(k);
        paintCard(k); paintTotals();
        qvClose();
      }
    });
    track.addEventListener('scroll', () => {
      const i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      if (i !== qv.i) { qv.i = i; qvDots(); }
    }, { passive: true });
    el.addEventListener('keydown', e => {
      if (e.key === 'Escape') { e.preventDefault(); qvClose(); return; }
      if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') { if (!e.target.closest('input,textarea')) qvGo(qv.i + (e.key === 'ArrowRight' ? 1 : -1)); return; }
      if (e.key !== 'Tab') return;
      const f = $$('button:not([disabled]):not([hidden])', $('.erx-qv__box', el)).filter(b => b.offsetParent !== null);
      if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    /* phone: drag the top bar down to close */
    const drag = $('.erx-qv__grab', el), box = $('.erx-qv__box', el);
    let y0 = null, dy = 0;
    drag.addEventListener('touchstart', e => { y0 = e.touches[0].clientY; dy = 0; box.style.transition = 'none'; }, { passive: true });
    drag.addEventListener('touchmove', e => { if (y0 == null) return; dy = Math.max(0, e.touches[0].clientY - y0); box.style.transform = 'translateY(' + dy + 'px)'; }, { passive: true });
    drag.addEventListener('touchend', () => { if (y0 == null) return; box.style.transition = ''; box.style.transform = ''; y0 = null; if (dy > 90) qvClose(); });
    return el;
  };

  const qvDots = () => {
    const el = qv.el, n = $$('[data-qv-slide]', el).length;
    $('[data-qv-pd]', el).innerHTML = n > 1 ? Array.from({ length: n }, (_, i) => '<i' + (i === qv.i ? ' class="on"' : '') + '></i>').join('') : '';
    $$('[data-qv-nav]', el).forEach(b => { b.hidden = n < 2; b.disabled = +b.dataset.qvNav < 0 ? qv.i <= 0 : qv.i >= n - 1; });
    $('.erx-qv__media', el).classList.toggle('has-dots', n > 1);
  };
  const qvGo = i => {
    const track = $('[data-qv-track]', qv.el), n = $$('[data-qv-slide]', qv.el).length;
    if (!n) return;
    qv.i = Math.max(0, Math.min(n - 1, i));
    track.scrollTo({ left: qv.i * track.clientWidth, behavior: 'smooth' });
    qvDots();
  };

  const qvPaint = newPhotos => {
    const el = qv.el, k = qv.k, it = items[k];
    const v = it.v.find(x => x.c === qv.c && x.ok) || variantOf(k);
    if (!v) return;
    qv.c = v.c;
    const bp = withDesk(k, v);
    /* brand names never break: "OmniARM PRO", "Omni MAT", "OmniSit Pro" keep their last word */
    $('[data-qv-nm]', el).textContent = ((W.t && W.t[k]) || it.name).replace(/ (PRO|Pro|MAT)\b/g, '\u00a0$1');
    const nx = n > 1 ? n + '&nbsp;×&nbsp;' : '';
    $('[data-qv-now]', el).innerHTML = nx + money(bp);
    const was = $('[data-qv-was]', el), note = $('[data-qv-note]', el);
    was.innerHTML = bp < v.price ? money(v.price) : ''; was.hidden = !(bp < v.price);
    note.textContent = bp < v.price && !chairPage ? W.ui.with_desk : ''; note.hidden = !note.textContent;
    const ok = it.v.filter(x => x.ok && x.n);
    const col = $('[data-qv-col]', el);
    col.hidden = ok.length < 2;
    $('[data-qv-cname]', el).textContent = v.n || '';
    const cardEl = card(k), hexes = $$('[data-erx-ao-dot]', cardEl).reduce((m, d) => { m[+d.dataset.erxAoDot] = d.style.getPropertyValue('--c'); return m; }, {});
    $('[data-qv-dots]', el).innerHTML = it.v.filter(x => x.n).map(x => '<button type="button" class="erx-qv__dot' + (x.c === v.c ? ' is-on' : '') + '" style="--c:' + esc(hexes[x.c] || '#ccc') + '" data-qv-dot="' + x.c + '" aria-label="' + esc(x.n) + '" aria-pressed="' + (x.c === v.c) + '"' + (x.ok ? '' : ' disabled') + '><i></i></button>').join('');
    const facts = (W.f && W.f[k]) || [];
    $('[data-qv-facts]', el).innerHTML = facts.map((f, i) => '<li>' + (i === 0 ? RULER : ICON.f[Math.min(i, 2)]) + '<span><b>' + esc(f[0]) + '</b><em>' + esc(f[1]) + '</em></span></li>').join('');
    const on = picked.has(k) && +cardEl.dataset.c === v.c;
    const add = $('[data-qv-add]', el);
    add.classList.toggle('is-on', on);
    add.innerHTML = on ? ICON.ok + '<span>' + esc(W.ui.remove) + '</span>' : '<span>' + esc(chairPage ? W.ui.add_chair : W.ui.add_desk) + ' · ' + nx + money(bp) + '</span>';
    const dv = deskVariant();
    /* Įmonei mode: the chairs at their tier price (erx-chair.js) plus a set per chair */
    let tot = mode === 'biz' && bizTotal ? bizTotal : (dv ? dv.price : 0);
    picked.forEach(x => { if (x === k) return; const pv = variantOf(x); if (pv) tot += withDesk(x, pv) * n; });
    tot += bp * n;
    $('[data-qv-tot]', el).innerHTML = esc(chairPage ? W.ui.tot_chair : W.ui.tot_desk) + ': <b>' + money(tot) + '</b>';
    if (newPhotos) {
      const list = pics(it, v), track = $('[data-qv-track]', el);
      track.innerHTML = list.map((u, i) => '<div class="erx-qv__slide" data-qv-slide><img src="' + esc(u) + '" srcset="' + esc(srcset(u)) + '" sizes="(max-width: 767px) 100vw, 640px" alt="' + esc(it.name) + (list.length > 1 ? ' ' + (i + 1) + '/' + list.length : '') + '" loading="' + (i < 2 ? 'eager' : 'lazy') + '" decoding="async"></div>').join('');
      track.scrollLeft = 0; qv.i = 0;
      qvDots();
    }
  };

  /* phone: if the last fact would sit under the pinned button (a 2-line name, a long language), the photo gives way by
     exactly that much, never below 176 px, so the whole photo AND all the text show without scrolling */
  const qvFit = () => {
    const el = qv.el;
    if (!el || el.hidden || !window.matchMedia('(max-width: 767px), (max-width: 1023px) and (orientation: portrait)').matches) return;
    const media = $('.erx-qv__media', el), box = $('.erx-qv__box', el), foot = $('.erx-qv__foot', el);
    const li = $$('.erx-qv__facts li', el).pop();
    media.style.maxHeight = '';
    if (!li) return;
    box.scrollTop = 0;
    const over = li.getBoundingClientRect().bottom + 8 - foot.getBoundingClientRect().top;
    if (over > 0) media.style.maxHeight = Math.max(176, Math.floor(media.getBoundingClientRect().height - over)) + 'px';
  };
  window.addEventListener('resize', () => { if (qv.k) qvFit(); });

  const qvOpen = (k, opener) => {
    if (!qvOn || !items[k] || !on()) return;
    const el = qvBuild();
    qv.k = k; qv.opener = opener || null;
    qv.c = +((card(k) || {}).dataset || {}).c || 0;
    el.hidden = false;
    qvPaint(true);
    requestAnimationFrame(() => { const t = $('[data-qv-track]', el); if (t) t.scrollLeft = 0; qvFit(); });
    document.documentElement.classList.add('erx-qv-lock');
    requestAnimationFrame(() => requestAnimationFrame(() => el.classList.add('is-open')));
    const x = $('.erx-qv__x', el);
    setTimeout(() => { try { x.focus({ preventScroll: true }); } catch (e) {} }, 30);
    try { (window.dataLayer = window.dataLayer || []).push({ event: 'erx_quick_view', erx_qv_key: k, erx_qv_item: items[k].name }); } catch (e) {}
  };
  const qvHide = () => {
    const el = qv.el;
    if (!el || el.hidden) return;
    el.classList.remove('is-open');
    document.documentElement.classList.remove('erx-qv-lock');
    const back = qv.opener;
    qv.k = null;
    setTimeout(() => { if (!qv.k) { el.hidden = true; $('[data-qv-track]', el).innerHTML = ''; } }, 220);
    if (back) { try { back.focus({ preventScroll: true }); } catch (e) {} }
  };
  /* No history entry for the phone's Back: GTM reads pushState as a page change (gtm.historyChange), which can count a
     page view per preview. X, the dimmed page, Esc and the swipe close it instead. */
  const qvClose = () => qvHide();

  /* progress bar + arrows follow the row */
  const bar = $('[data-erx-ao-bar]', root);
  const navs = $$('[data-erx-ao-nav]', root);
  const paintRow = () => {
    if (!track) return;
    const max = track.scrollWidth - track.clientWidth;
    const vis = track.scrollWidth ? track.clientWidth / track.scrollWidth : 1;
    if (bar) {
      bar.style.width = Math.max(12, Math.min(100, vis * 100)) + '%';
      bar.style.transform = 'translateX(' + (max > 0 ? (track.scrollLeft / max) * ((1 - vis) / vis) * 100 : 0) + '%)';
    }
    navs.forEach(n => { n.disabled = +n.dataset.erxAoNav < 0 ? track.scrollLeft <= 2 : track.scrollLeft >= max - 2; });
  };
  if (track) { track.addEventListener('scroll', paintRow, { passive: true }); window.addEventListener('resize', paintRow); }

  /* erx-chair.js repaints the price, the button and the bar on every variant / mode change, then fires erx:variant
     on the block (it does not bubble). Re-apply the total after it. */
  if (top) top.addEventListener('erx:variant', e => {
    mode = (e.detail && e.detail.mode) || 'me';
    n = BIZ && mode === 'biz' ? Math.max(1, +(e.detail && e.detail.qty) || 1) : 1;
    bizTotal = mode === 'biz' ? +(e.detail && e.detail.total) || 0 : 0;
    /* erx-chair.js has just written the chairs-only line; keep it to add the picks to */
    const sub = $('[data-erx-bar-sub]');
    bizSub = mode === 'biz' && sub ? sub.textContent : null;
    root.hidden = !on();
    followFrame();
    sizeFit();
    paintAll();
    paintRow();
  });

  /* the add: capture phase, so it runs before erx-chair.js's own listener and only when something is picked */
  let adding = false;
  const addAll = async btn => {
    const c = window.cart;
    const desk = deskId();
    const addons = Array.from(picked).map(variantOf)
      .filter(v => v && v.ok && !(window.ErgonixOOS && window.ErgonixOOS.isVariantSoldOut && window.ErgonixOOS.isVariantSoldOut(v.id)))
      .map(v => String(v.id));
    const q = n;
    const list = [{ id: desk, quantity: q }].concat(addons.map(id => ({ id: id, quantity: q })));
    if (!c || typeof c._enqueue !== 'function' || typeof c.renderCart !== 'function') {
      /* cart.js missing: post the lot and land on the cart page */
      try { await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: list }) }); } catch (e) {}
      window.location.href = '/cart';
      return;
    }
    if (typeof c._claimAdd === 'function' && !c._claimAdd(desk)) return;
    adding = true;
    const pend = typeof c._beginPendingAdd === 'function' ? list.map(i => c._beginPendingAdd(i.id, i.quantity)) : [];
    try { if (c._paint) c._paint(); } catch (e) {}
    if (c.openDrawer) c.openDrawer();
    let ok = false;
    await c._enqueue(async () => {
      try {
        const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: list }) });
        ok = r.ok;
      } catch (e) { ok = false; }
      finally {
        pend.forEach(p => { try { c._endPendingAdd(p); } catch (e) {} });
        try { if (c._cartWritten) c._cartWritten(); } catch (e) {}
        if (c._addInFlight) c._addInFlight.delete(desk);
      }
      await c.renderCart();
      if (c._pendingQty && c._pendingQty.size && c._scheduleFlush) c._scheduleFlush(0);
    });
    adding = false;
    if (ok) { picked.clear(); paintAll(); return; }
    /* one add-on refused (sold out in the meantime): the desk must still go in */
    if (c.addToCart) c.addToCart(desk, q);
  };
  document.addEventListener('click', e => {
    const btn = e.target.closest && e.target.closest('[data-erx-atc], [data-erx-bar-atc]');
    if (!btn || !on() || !picked.size || btn.disabled) return;
    if (!totals().deskOk) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (adding) return;
    addAll(btn);
  }, true);

  followFrame();
  sizeFit();
  paintAll();
  paintRow();
})();
